var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBonegoCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9039 8.1572C15.1352 7.89884 15.1132 7.50187 14.8549 7.27056C14.5965 7.03925 14.1995 7.06118 13.9682 7.31954L11.1475 10.4701C10.576 11.1085 10.1911 11.5362 9.86197 11.8128C9.54847 12.0763 9.36434 12.1337 9.20349 12.1337C9.04264 12.1337 8.8585 12.0763 8.54501 11.8128C8.21592 11.5362 7.831 11.1085 7.25944 10.4701L6.53176 9.65733C6.30045 9.39897 5.90349 9.37704 5.64512 9.60835C5.38676 9.83967 5.36483 10.2366 5.59614 10.495L6.3549 11.3425C6.88724 11.9371 7.33127 12.4331 7.73699 12.7741C8.16618 13.1349 8.6291 13.3895 9.20349 13.3895C9.77788 13.3895 10.2408 13.1349 10.67 12.7741C11.0757 12.4331 11.5197 11.9371 12.052 11.3425L14.9039 8.1572Z",
    fill: "#009B90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.25 1.25C5.27944 1.25 1.25 5.27944 1.25 10.25C1.25 15.2206 5.27944 19.25 10.25 19.25C15.2206 19.25 19.25 15.2206 19.25 10.25C19.25 5.27944 15.2206 1.25 10.25 1.25ZM2.50581 10.25C2.50581 5.973 5.973 2.50581 10.25 2.50581C14.527 2.50581 17.9942 5.973 17.9942 10.25C17.9942 14.527 14.527 17.9942 10.25 17.9942C5.973 17.9942 2.50581 14.527 2.50581 10.25Z",
    fill: "#009B90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonegoCheck);
export default __webpack_public_path__ + "static/media/bonego_check.97397c1840f7a29c193b6a8473524c2b.svg";
export { ForwardRef as ReactComponent };